export default __webpack_public_path__ + "static/media/5.a8ab62f3.jpg";